import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/CreateTopicService";
const store = {};
const mutations = { 
    GET_TOPICTYPES_FOR_CREATION(state, posts) {
        state.topicTypeList = posts.list;
        state.topicTypeListIsLoading = false;
    }, 
};
const state = {
    topicTypeListIsLoading: false,
    topicTypeList: [], 
};
const getters = {};
const actions = {
    getTopicTypesForCreation({ commit }) {
        state.topicTypeListIsLoading = true;
        axios
            .get(baseUri + '/GetTopicTypesForCreation')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPICTYPES_FOR_CREATION', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    }, 
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}